import React, { FC, useContext, useState } from 'react'
import { Button, Form, Modal, Spinner } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import DialogContext from '../Authentication/DialogContext'
import { hideDialog } from '../utils/DialogUtil'
import DraggableModalDialog from './DraggableModalDialog'

const SelectDialog: FC<{ selectDialogProps: SelectDialogProps }> = ({ selectDialogProps: props }) => {
  const { t } = useTranslation()
  const {
    show,
    backdrop = true,
    header = t('editDialog.header'),
    data = [],
    keyField,
    label,
    submitText = t('submit'),
    onSubmit,
    onSubmitExtraArgs = [],
    showCancelButton = true,
    cancelText = t('cancel'),
    footerPrefix,
  } = props
  const [validated, setValidated] = useState(false)
  const [submitting, setSubmitting] = React.useState(false)
  const [form, setFormValues] = useState(data[0])
  const { selectDialogPropsSetter } = useContext(DialogContext)

  const handleSubmit = (event: any) => {
    setSubmitting(true)
    const formTarget = event.currentTarget
    event.preventDefault()
    if (formTarget.checkValidity() === false) {
      event.stopPropagation()
    } else {
      onSubmit(...onSubmitExtraArgs, form)
      hideDialog(selectDialogPropsSetter)
    }
    setSubmitting(false)
    setValidated(true)
  }

  const updateControlField = (e: any) => {
    setFormValues(data.find((datum) => datum[keyField] === e.target.value))
  }

  return (
    <>
      <Modal
        dialogAs={DraggableModalDialog}
        show={show}
        onHide={() => hideDialog(selectDialogPropsSetter)}
        backdrop={backdrop}
        size='lg'
        aria-labelledby='contained-modal-title-vcenter'
        centered
        className='modal-dark'>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title id='contained-modal-title-vcenter'>{header}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group>
              <Form.Label>{label}</Form.Label>
              <Form.Control as='select' onChange={updateControlField}>
                {data.map((selectData) => (
                  <option key={selectData[keyField]} value={selectData[keyField]}>
                    {selectData[keyField]}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            {footerPrefix}
            <Button type='submit' disabled={submitting} block={true} className='w-auto'>
              {submitting ? (
                <>
                  <Spinner as='span' animation='border' size='sm' role='status' aria-hidden='true' />
                  <span className='ml-1'>{t('submitting')}</span>
                </>
              ) : (
                submitText
              )}
            </Button>
            {showCancelButton && (
              <Button variant='danger' onClick={() => hideDialog(selectDialogPropsSetter)}>
                {cancelText}
              </Button>
            )}
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  )
}

export type SelectDialogProps = {
  show: boolean
  backdrop?: 'static' | true | false
  header?: string | JSX.Element
  data: any[]
  keyField: string
  label: string
  onSubmit: (...args: any[]) => any
  onSubmitExtraArgs?: any[]
  submitText?: string
  showCancelButton?: boolean
  cancelText?: string
  footerPrefix?: JSX.Element
}

export default SelectDialog
